import React from "react";

function ConnectAdPost() {
  return <div>ConnectAdPost.</div>;
}

export default ConnectAdPost;
